import { render } from "./FormDataAnak.vue?vue&type=template&id=3da60be5"
import script from "./FormDataAnak.vue?vue&type=script&lang=js"
export * from "./FormDataAnak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__